import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const BoardImageIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21 2.20001H3C1.35 2.20001 0 3.55001 0 5.20001V18.8C0 20.45 1.35 21.8 3 21.8H21C22.65 21.8 24 20.45 24 18.8V5.20001C24 3.55001 22.65 2.20001 21 2.20001ZM3 4.20001H21C21.55 4.20001 22 4.65001 22 5.20001V13.16L17.04 9.03001C16.67 8.72001 16.13 8.72001 15.76 9.03001L10.68 13.26L8.24 11.23C7.87 10.92 7.33 10.92 6.96 11.23L2 15.36V5.20001C2 4.65001 2.45 4.20001 3 4.20001ZM21 19.8H3C2.45 19.8 2 19.35 2 18.8V17.97L7.6 13.3L10.04 15.33C10.41 15.64 10.95 15.64 11.32 15.33L16.4 11.1L22 15.77V18.8C22 19.35 21.55 19.8 21 19.8Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

BoardImageIcon.displayName = 'BoardImageIcon';
